import { Injectable } from '@angular/core';
import { Weaver as WeaverCore, WeaverBase } from '@skylab-shared/core';
import { Wrapper } from '../wrapper/wrapper';

export { WeaverCore as WeaverBase };

@Injectable({providedIn: 'root'})
@Wrapper(WeaverBase, { static: true })
export class Weaver { }
